<app-base-sent-count-statistics
  [title]="title"
  [getMonthlyItemsApiMethodName]="getMonthlyItemsApiMethodName"
  [getDailyItemsApiMethodName]="getDailyItemsApiMethodName"
  [isShowOrganizationDropDown]="false"
  [isShowUserDropDown]="false"
  [doughnutChartId]="doughnutChartId"
  [barChartId]="barChartId"
  statisticalReportsCompareType="user"
>
</app-base-sent-count-statistics>
